import type { ArgsProps } from 'antd/es/notification/interface';

export type EventDetails = Pick<ArgsProps, 'message' | 'description'>;

export type ShowApiErrorEvent = CustomEvent<EventDetails>;

export const SHOW_API_ERROR_EVENT = 'showApiError';

export const showApiError = (
    data: Pick<ArgsProps, 'message' | 'description'>,
) => {
    const event = new CustomEvent<EventDetails>(SHOW_API_ERROR_EVENT, {
        detail: data,
    });

    document.dispatchEvent(event);
};
